import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

import { FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';
import { GridDNDConfig, PopUpManager, WizActionObj, WizBasePopUp, WizDatasource, WizDropdown, WizEvent, WizEventManager, WizHgroup, WizIcon, WizPopUp, WizTabBar, WizTabButton, WizTranslationManager, WizValidationContainerDirective, WizValidationError, WizVgroup } from '@wizeoo/akm-component-lib';
import { VALUE_ENTER, VALUE_ESCAPE, WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { PivotFunction } from '../../../../manager/baselines/pivot-function.obj';
import { StyleEngine } from '../../../../manager/workingdata/style.engine';
import { WIDGET_GLOBAL_KIND, WIDGET_KIND } from '../../../../model/enums';
import { Model } from '../../../../model/model';
import { ViewData } from '../../../../model/view.data';
import { ColorPickerPop } from '../../../colorpicker/color-picker.pop';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { FeiVO } from '../../../../vo/workingdata/fei.vo';
import { FormatVO } from '../../../../vo/workingdata/format.vo';
import { StyleVO } from '../../../../vo/workingdata/style.vo';
import { FakeVO } from '../../../../vo/common/tool/fake.vo';
import { CssRenderVO } from '../../../../vo/workingdata/cssrender.vo';
import { ColDef } from 'ag-grid-community';
import { GridOptions } from '@ag-grid-community/core';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';
import { clone } from 'lodash-es';
import { HeaderEditStyleSubPop } from '../../pivot/renderers/header/header-edit-style.sub.pop';




@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'freedata-header-edit-pop',
  templateUrl: './freedata-header-edit.pop.html',
})
export class FreedataHeaderEditPop extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
   
    if (event.key === VALUE_ENTER) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.doCancel();
    }
  }  

  public model: Model;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;

  /** barre de navigation */
  @ViewChild('tabBar', { read: WizTabBar, static: true }) tabBar: WizTabBar;


  @ViewChild('gpColumn', { read: WizVgroup }) gpColumn: WizVgroup; // zone colonnes
  @ViewChild('gpColumn', { read: WizValidationContainerDirective }) private gpColumnValidator: WizValidationContainerDirective; // validateur des champs de saisie des colonnes

  @ViewChild('gpHeader', { read: WizVgroup }) gpHeader: WizVgroup; // zone rendu du header (couleurs)
    @ViewChild('ddCssStyle', { read: WizDropdown }) ddCssStyle: WizDropdown; // drop de choix du style

  
  @ViewChild('blockFont') blockFont: ElementRef; // zone de dessin de la couleur de font
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background

  @ViewChild('gpFormat', { read: WizVgroup }) gpFormat: WizVgroup; // zone format, type de champ et aggrégat
  // @ViewChild('ddFunc', { read: WizDropdown }) ddFunc: WizDropdown; // drop de choix de la fonction
  @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // drop de choix du formatage
  @ViewChild('ddField', { read: WizDropdown }) ddField: WizDropdown; // drop de choix du champ de label des FDVs
  // @ViewChild('ddChronoField', { read: WizDropdown }) ddChronoField: WizDropdown; // drop de choix du champ de label des Chronos

  @ViewChild('gpStyle', { read: WizVgroup }) gpStyle: WizVgroup; // zone style
  @ViewChild('cellColors', { read: WizHgroup }) cellColors: WizHgroup; // groupe de la zone de dessin
  @ViewChild('cellBlockFont') cellBlockFont: ElementRef; // zone de dessin de la couleur de font
  @ViewChild('cellBlockBack') cellBlockBack: ElementRef; // zone de dessin de la couleur de background
  @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown; // drop de choix du style
  @ViewChild('btEditStyle', { read: WizIcon }) btEditStyle: WizIcon; // bouton update du style

  @ViewChild('gpFilterFields', { read: WizVgroup }) gpFilterFields: WizVgroup; // champs complémentaires pour les filtres
  

  /* ##############################################################################
          prises de tailles
  ############################################################################## */

  public static baseHeight: number = 500; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 500; // largeur, statique pour prise externe sur ouverture

  // public realHeight: number = 0; // hauteur réelle, on va soustraire ce qui est masqué


  /* ##############################################################################
                  paramètres d'affichage
  ############################################################################## */

  useContent:boolean = false; // gestion du détail de la mesure / de la formule


  useColumn:boolean = false; // groupe resize taille & taille min
  isFilter: boolean = false; // utilisation du groupe colonne pour taille de filtre
  // columnHeight: number = 85;


  headTab: boolean = false;
  //useHeader:boolean = false; // groupe configuration de l'entête
  // headerHeight: number = 135; 
    useHeaderGroup:boolean = false; // groupe de colonnes
    useHeaderInherit: boolean = false; // héritage du style de la colonne parente
    useHeaderHideFilter:boolean = false; //filtre, filtre masqué
    useHeaderOnlyExist:boolean = false; // filtre, seulement l'existant
    useHeaderTextAlign:boolean = false; // alignement du texte
    useHeaderColors:boolean = false; // couleurs d'entête

  contentTab: boolean = false;

  // useFormat:boolean = false; // groupe configuration de l'entête
  // formatHeight: number = 85;
    useFormatField:boolean = false; // champ sur le FDV
    useFormatSubField:boolean = false;// sous-champ sur FDV
    useFormatChronoField:boolean = false; // champ sur le chronocode
    useFormatAggregate:boolean = false; // drop de méthode d'aggrégat
    useFormatReadonly:boolean = false; // champ en readOnly
    useMassEditSplit:boolean = false; // massEdit en mode split
  
  useStyle:boolean = false; // rendu des cellules (statique et dynamique)
  useCssStyle:boolean = false; // style des filtres
  // styleHeight: number = 85;

  filterTab: boolean = false;
  useSearchFields:boolean = false; // champs de rendu pour les drops
  // searchFieldsHeight: number = 250;
  
  advancedTab: boolean = false;

  /* ##############################################################################
                données
  ############################################################################## */

  /** la DS des fonctions d'aggrégat */
  public functionDS: WizDatasource<PivotFunction> = new WizDatasource<PivotFunction>(
    Array.from([])
  )
    .setFilter(this.dataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build();

  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.dataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les FDVs */
  public fieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les Chronos */
  public chronoFieldDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();


  /** la DS des styles */
  public styleDS: WizDatasource<StyleVO> = new WizDatasource<StyleVO>([])
    .setItemCodeField('fullCode')
    .setSortFields([{ property: 'fullCode', way: 'asc', numeric: false }])
    .build();

  /** DS du grid des champs de sélection pour les FDVs */  
  public fieldsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFn(this.sortSelectedFirst.bind(this))
    // .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('multiple')
    .build();

  /** DS du sous-champ pour les FDVs */  
  public subFieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
  .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
  .setSelectionMode('single')
  .build();
  

  /** DS groupes de colonnes */  
  public groupDS: WizDatasource<PivotField> = new WizDatasource<PivotField>([])
    .setSelectionMode('single')
    .build();

  /** DS alignement des entêtes */
  public headerAlignDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des styles */
  public cssStyleDS: WizDatasource<CssRenderVO> = new WizDatasource<CssRenderVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();



  // champs complémentaires pour affichage des drops
  public searchFields: string[] = []; 

  // colonne du grid des champs complémentaires
  columns: ColDef[] = [
    { headerName: '$.field.shortcode.$', dndSource: true, flex: 1, sortable: true, field: 'trsLabel' }
  ];
  gridOptions: GridOptions = {
  };

  // configuration du drag sur la liste des champs de sélection
  dndConfig: GridDNDConfig<FreedataArgsVO> = {
    dragEnabled: true,
    dropEnabled: true,
    dropAction: 'reorder'
  };


  /* ##############################################################################
          éléments de cycle de vie & cycle de vie
  ############################################################################## */
  public declare datas: widgetHeaderVO; // le contrat de données pour la pop
  public clone: PivotField = null; // le clone de travail
  public arg: FreedataArgsVO; // le arg en cours

  public show(): void {
    super.show();

    this.model = this.datas.widget.model;

    this.functionDS.setSource([...this.model.aggregateEngine.functionMap().values()]);
    if(!!this.model.formatEngine.getFormatList()) {
      this.formatDS.setSource([...this.model.formatEngine.getFormatList()]);
    }
    this.chronoFieldDS.setSource(this.model.chronocodeEngine.getChronoFields());
    this.headerAlignDS.setSource([...ViewData.getInstance().textAlignList]);
    if(!!this.model.styleList) {
      this.styleDS.setSource(this.model.styleList);
    }

    // TODO filter à la BU
    if(!!this.model.styleEngine.getCssRenderList()) {
      this.cssStyleDS.setSource(this.model.styleEngine.getCssRenderList());
    }


    this.clone = clone(this.datas.pivotField);
    this.manageTabs();
    this.feed(); // alimentation des données et DS
    this.manageVisibility();
    this.addListeners();
    // this.getMyRealSize();
  }

  private stylePop: WizPopUp; // la popUp d'édition des styles
  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)


  public titleLabel: string = null; // titre de la popUp
  public contentLabel: string = null; // libellé du contenu
  
  public customHeaderTitle: string = null; // override du titre de la colonne
  public hideFilter: boolean = false; // masquer le filtre
  public onlyExist: boolean = false; // afficher uniquement les valeurs dispo

  colWidth: number = null; // taille de la colonne
  colMinWidth: number = null; // taille min
  colResize: boolean = true; // resize autorisé
  colAuto: boolean = false; // flex 1
  exportable: boolean = false; // pas inclus dans l'export
  public headInherit: boolean = false;



  public readOnly: boolean = false; // champ en readOnly
  public massEditSplit: boolean = false; // mode split sur massEdit
  /** activation du bouton d'édition des styles */
  public get editStyleEnabled(): boolean {
    return !!this.styleDS?.selectedItem;
  }

  /** gestion des styles */
  public get mayEditStyle(): boolean {
    return this.datas?.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE;
  }

  /**
   * activation de la colonne taille min
   */
  public get resizeEnabled(): boolean {
    return this.clone?.colRezisable
  }
  


  // styles de headers
  public fontColor = 'unset'; // StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
  public backgroundColor = 'unset'; // StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
  public css: any = null;

  // styles de cellules
  public cellFontColor = StyleEngine.STYLE_DEFAULT_CELL_FONT_COLOR; // --grid-header-color
  public cellBackgroundColor = StyleEngine.STYLE_DEFAULT_CELL_BACKGROUND_COLOR; // --grid-header-background-color
  public cellCss: any = null;

  // conf complémentaire (settings sur workflow)
  public moreSettings: string = null;


  /** sur séquence de démarrage, alimentation des données */
  public feed(): void {
    // titre de la popUp
    if(this.datas.pivotField.isFreeFilter) {
      this.titleLabel = WizTranslationManager.getInstance().translateKey('$.common.free.filter.$');
    } else {
      this.titleLabel = this.model.feiEngine.getFeiKeyDefTechnicalLabel(this.datas.pivotField.fkd);
    }
   

    // formule en cas de mesure
    if (this.datas.pivotField.fkd.isMeasure) {
      this.contentLabel = this.datas.pivotField.fkd.measure['formula' + this.datas.pivotField.mode]; // formule du champ
    }

    // libellé custom pour la colonne
    this.customHeaderTitle = this.datas.pivotField.labelOrDefaultLabel;
    // masquer le filtre
    this.hideFilter = this.datas.pivotField.filtHide; 
    // afficher uniquement les valeurs dispo
    this.onlyExist = this.datas.pivotField.filtOnlyExist; 

    // gestion de la taille de colonne
    this.colWidth = this.datas.actualWidth??this.datas.pivotField.colSize; // On prend la largeur actuelle, sinon la largeur dans le champ de configuration
    this.colResize = this.datas.pivotField.colRezisable;
    this.colAuto = this.datas.pivotField.colAutoSize;
    this.colMinWidth = this.colResize ? this.datas.pivotField.colMinSize: null;
    this.exportable =  this.datas.pivotField.exportable;

    // gestion des groupes de colonnes
    if(this.datas.currentGroups?.length > 0) {
      this.groupDS.setSource(this.datas.currentGroups); 
      let initPiv: PivotField = null;
      if (!!this.datas.pivotField.parentGroup) {
        this.groupDS.getSource().forEach((pf: PivotField) => {
          if (this.datas.pivotField.parentGroup === pf.fkd.code) {
            initPiv = pf;
          }
        });
      }
      this.groupDS.select([initPiv]);
    }
    this.headInherit = this.datas.pivotField.headInherit;


    // gestion du style
    let style: StyleVO = null; // le style
    let styleSplit: string[] = null;
    if (this.datas.pivotField.style) {
      styleSplit = this.datas.pivotField.style.split(ViewData.KEY_SEPARATOR);
      style = this.model.styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultStyle) {
      styleSplit = this.datas.pivotField.fkd.defaultStyle.split(ViewData.KEY_SEPARATOR);
      style = this.model.styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    }
    this.styleDS.select([style]);


    let cssstyle: CssRenderVO = null; // le style 
    if (this.datas.pivotField.style) {
      cssstyle = this.cssStyleDS.getItemByKey(this.datas.pivotField.style);
    }
    this.cssStyleDS.select([cssstyle]);
    // if(!!this.ddCssStyle) {
    //   this.ddCssStyle.wizDataProvider = this.cssStyleDS;
    // }
    

    // gestion du rendu du header, alimentation font & background
    if (!!this.datas.pivotField.headerStyle) {
      const styleParts: string[] = this.datas.pivotField.headerStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.backgroundColor = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.fontColor = styleParts[1];
      }
    }

    // construction du CSS actif pour les colonnes
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);
    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);
    
    // gestion du rendu des cellules, alimentation font & background
    if (!!this.datas.pivotField.cellStyle) {
      const styleParts: string[] = this.datas.pivotField.cellStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.cellBackgroundColor = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.cellFontColor = styleParts[1];
      }
    }

    // construction du CSS actif pour les cellules
    const cellParts: string[] = [];
    cellParts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellFontColor);
    cellParts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellBackgroundColor);
    this.cellCss = cellParts.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    // gestion du groupe de colonne
    const func: string = this.datas.pivotField.aggOrDefaultFunc();
    this.functionDS.refresh();
    this.functionDS.select([this.functionDS.getItemByKey(func)]);
 
    // gestion du format
    this.formatDS.refresh(); // actualisation de la drop des formats
    let format: FormatVO = null; // le format de données
    let formatSplit: string[] = null;
    if (this.datas.pivotField.format) {
      formatSplit = this.datas.pivotField.format.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultFormat) {
      formatSplit = this.datas.pivotField.fkd.defaultFormat.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    }
    this.formatDS.select([format]);

    // gestion de l'alignement des headers
    let headerAlign: FakeVO = null; // le format de données
    let ha: string = this.datas.pivotField.headerAlign;
    headerAlign = this.headerAlignDS.getItemByKey(ha);
    this.headerAlignDS.select([headerAlign]);

    this.readOnly = this.datas.pivotField.readOnly;
    this.massEditSplit = this.datas.pivotField.massSplit;

    if(this.datas.pivotField.fkd.isFreedata) {
      // gestion du field des FDVs
      const argSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
      this.fieldDS.setSource(argSrc ? [...argSrc] : []);

      let field: FreedataArgsVO = null; // le champ de FDVs
      if (this.datas.pivotField.fdvField) {
        field = this.fieldDS.getItemByKey(this.datas.pivotField.fdvField);
      }
      this.fieldDS.select([field]);
    } else if (this.datas.pivotField.fkd.isChrono) {
      
      let field: FakeVO = null; // le champ de chrono
      if (this.datas.pivotField.fdvField) {
        field = this.chronoFieldDS.getItemByKey(this.datas.pivotField.fdvField);
        // console.log('head field', field);
      } 
      this.chronoFieldDS.select([field]);
    }
    

    if (!!this.datas.pivotField.fdvSearch) { // champs sélectionné pour rendu des pops de sélection
      this.searchFields = this.datas.pivotField.fdvSearch.split(ViewData.KEY_SEPARATOR);
    }

    this.resetSubFields(); // construction de la collection de subFields pour rendu pop

    // trier fieldsDS par fdvSearch
    if (!!this.searchFields && this.searchFields.length > 0) { // champs sélectionné pour rendu des pops de sélection
      const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
      this.fieldsDS.select(valArgs);
      this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
    } 

    this.customHeaderTitle = this.datas.pivotField.label ? this.datas.pivotField.label : this.arg ?.trsLabel; // libellé du champ

    // gestion des settings sur workflow
    this.moreSettings = this.datas.pivotField.pmdexParams;

  }
  
  /** gestion de la visibilité des zones de configuration, selon le widget et sa conf */
  public manageVisibility(): void {
    
    // this.realHeight = this.titleHeight;
    // this.realHeight += this.footerHeight;
    // this.ready = true;

    //### gestion de la zone "content", uniquement si formula
    if (this.contentLabel?.length > 0) {
      // console.log('useContent');
      this.useContent = true;
      // this.realHeight += this.contentHeight;
    }

    //### gestion du rendu d'entête
    let useHeader: boolean = this.datas.popUpMode === WIDGET_KIND.PIVOT 
      || this.datas.popUpMode === WIDGET_KIND.GRID 
      || this.datas.popUpMode === WIDGET_KIND.FORM 
      || this.datas.popUpMode === WIDGET_KIND.TILE 
      || this.datas.popUpMode === WIDGET_KIND.GLOBAL_FILTER  
      || this.datas.popUpMode === WIDGET_KIND.TIMELINE;

    if (useHeader) {
      // this.headTab = true;
      // this.realHeight += this.headerHeight;
      // console.log('useHeader', this.realHeight);

      if (this.datas.baseCollector?.id === 'lstFilter') { // mode édition des filtres: libellé et masqué
        this.useHeaderHideFilter = true;
        if(this.datas.popUpMode !== WIDGET_KIND.GLOBAL_FILTER) { // pas de restriction sur globalFilter)
          this.useHeaderOnlyExist = true;
        } 
      } else { // pas les filtres, on peut choisir les couleurs de header
        this.useHeaderTextAlign = true;
        this.useHeaderColors = true;
      }

      if (
        (this.datas.popUpMode === WIDGET_KIND.GRID ||
        this.datas.popUpMode === WIDGET_KIND.FD_GRID)   
        && 
        this.datas.currentGroups?.length > 0) {
        this.useHeaderGroup = true;
        this.useHeaderInherit = true;
      }
    }

    // console.log('baseCollector', this.datas.baseCollector?.id);

    //### gestion de la zone 'apparence de colonne' 
    let useColumn: boolean = 
          !this.datas.baseCollector || // directement depuis une colonne
          (this.datas.baseCollector.id === 'lstData' && this.datas.popUpMode !== WIDGET_KIND.TIMELINE) || 
          this.datas.baseCollector.id === 'lstRow'
          ;

    let isFilter: boolean = this.datas.baseCollector?.id === 'lstFilter';
    this.isFilter = isFilter;
          
    // en édition directe depuis les headers de grid (pas de baseCollector) 
    // ou depuis les champs en row ou data
    if (useColumn || isFilter) {
      // mode configuration ou resize autorisé, affichage de la zone colonne
      if ((this.datas.widget && this.datas.widget.templatingMode) || !!this.datas.pivotField.colRezisable) {
        this.useColumn = true;
      } 
    }

    //### gestion du format
    // this.contentTab = true;
    // this.realHeight += this.formatHeight;
    // console.log('useFormat', this.realHeight);
    // gestion de la fonction d'aggrégat, sur les pivots ou en mode liste
    if (
      (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
        this.datas.popUpMode === WIDGET_KIND.LIST || 
        this.datas.popUpMode === WIDGET_KIND.FORM || 
        this.datas.popUpMode === WIDGET_KIND.CHART) 
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.place === 'data')
        && this.datas.widget?.pivotMode === true
      ) {
        this.useFormatAggregate = true;
    } 

    // choix du label sur les FDVs
    if (!!this.datas.pivotField.fkd.isFreedata) {
      this.useFormatField = true;
    }

    // en mode FREEDATA, utilisation possible du subField pour le rendu
    if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA &&
      this.arg?.dataType === FIELD_KIND.OBJECT) {
      this.useFormatSubField = true;
    } else {
      this.useFormatSubField = false;
    }


    // choix du label sur les chronos
    if (!!this.datas.pivotField.fkd.isChrono && this.datas.baseCollector?.id !== 'lstFilter') {
      this.useFormatChronoField = true;
    }

    // gestion du lecture seule
    if (
      this.datas.baseCollector?.id === 'lstData' || 
      this.datas.place === 'data' || 
      this.datas.baseCollector?.id === 'lstRow' ||
      this.datas.place === 'row'  
    ) {
      this.useFormatReadonly = true;
    }

    // gestion du massEdit en mode split
    if (
      (this.datas.popUpMode === WIDGET_KIND.PIVOT || this.datas.popUpMode === WIDGET_KIND.GRID) 
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.baseCollector?.id === 'lstRow'
        || this.datas.place === 'data' || this.datas.place === 'row')
        && this.datas.pivotField.fkd?.editable // mesure éditable
        && this.datas.widget?.context?.hme
    ) {
      this.useMassEditSplit = true;
    }


    //### gestion du style
    if ( (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
          this.datas.popUpMode === WIDGET_KIND.GRID) && // pivot ou grid
         (!this.datas.baseCollector ||
          this.datas.baseCollector.id === 'lstData' ||
          this.datas.baseCollector.id === 'lstRow')) { // uniquement pour row & data
      this.useStyle = true;
      // this.realHeight += this.styleHeight;
      // console.log('useStyle', this.realHeight);
    } 


    //### gestion du style sur les filtres
    // if ( (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
    //       this.datas.popUpMode === WIDGET_KIND.GRID) && // pivot ou grid
    //      this.datas.baseCollector?.id === 'lstFilter') { // uniquement pour row & data
      this.useCssStyle = true;
      // console.log("where", this.datas.popUpMode, this.datas.baseCollector?.id);
    // } 


    

    // visible dans les filtres
    // visibles pour les FilterKey en row / data pour les baselines
    // visible pour le globalFilter (juste filtre)

    // let useSearchFields: boolean = false;
    // if (this.datas.pivotField.fkd?.isKey) { // il faut que ce soit une clé
    //   if (this.datas.popUpMode === WIDGET_KIND.GLOBAL_FILTER) { // filtre global
    //     useSearchFields = true;
    //   } 
    if(this.datas.baseCollector?.id === 'lstFilter') { // en filter, OK
        if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA &&
          this.arg?.dataType  === FIELD_KIND.OBJECT) {
            // console.log('useSearchFields');
            this.useSearchFields = true;
        }
    }

    //   } else if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE
    //     && this.datas.pivotField.fkd?.isFilterKey) { // un widget baseline en filterKey
    //     useSearchFields = true;
    //   }
    // }

    // if(useSearchFields) {
    //   this.filterTab = true;
    //   this.realHeight += this.searchFieldsHeight;
    //   // console.log('useSearchFields', this.realHeight);
    // } else {
    //   this.filterTab = false;
    // }
  }

  /** définition de la bonne taille */
  // protected getMyRealSize(): void {
  //   if (this.realHeight !== FreedataHeaderEditPop.baseHeight) {
  //     // console.log("delta size", this.realHeight);
  //     this.datas.popReference.dialogRef.updateSize(FreedataHeaderEditPop.baseWidth + 'px', this.realHeight + 'px');
  //   }
  // }


  // protected resetSubFields(): void {
  //   if(this.datas.pivotField.fkd.isFreedata) {
  //     const field: FreedataArgsVO = this.fieldDS.selectedItem; // le champ de FDVs
  //     if (!!field && field.dataType === FIELD_KIND.OBJECT) { // un champ custom est sélectionné. Si c'est un objet, c'est lui qui donne le contenu des champs de pops
  //     const subArgSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(field.datas.split(ViewData.CONTEXT_SEPARATOR)[0]);
  //     this.fieldsDS.setSource(subArgSrc ? [...subArgSrc] : []);
  //    } else {
  //     const argSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
  //     this.fieldsDS.setSource(argSrc ? [...argSrc] : []);
  //    }

  //    if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !== field?.dataType) {
  //     this.formatDS.clearSelection();
  //    } 

  //   } else if(this.datas.pivotField.fkd.isChrono) { // chrono ou autre
  //     const fake: FakeVO = this.model.chronocodeEngine.getChronoFieldByCode(this.chronoFieldDS.selectedItem?.code);
  //     if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !==  fake?.datakind) {
  //       this.formatDS.clearSelection();
  //     } 
  //   }

  //   this.formatDS.refresh();
  // }


  /** mise en place des écouteurs */
  public addListeners(): void {
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.clicOnTab); // écoute sélection d'un onglet
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value, e.component);
    switch (e.component.id) {
      case 'tiLabel':
        this.clone.label = e.value;
        break;
      case 'cbHideFilter':
        this.clone.filtHide = e.value === '1' ? true : false;
        break;
      case 'cbExistValueFilter':
        this.clone.filtOnlyExist = e.value === '1' ? true : false;
        break;
      case 'ddField':
        this.clone.fdvField = this.fieldDS.selectedItem?.code || null;
        this.resetSubFields();
        break;
      case 'ddSubField':
        this.clone.fdvSubField = this.subFieldDS?.selectedItem?.code || null;
        this.resetSubFields();
        break;
      case 'ddChronoField':
        this.resetSubFields();
        break;
      case 'cbColResize': 
        this.clone.colRezisable = e.value === '1' ? true : false;
        this.checkSize();
        break;
      case 'cbColAuto': 
        this.clone.colAutoSize = e.value === '1' ? true : false;
        break;          
      case 'cbExport': 
        this.clone.exportable = e.value === '1' ? true : false;
        break;   
      case 'niColMinWidth': 
        this.clone.colMinSize = Number(e.value);
        this.checkSize();
        break;
      case 'niColWidth': 
        this.clone.colSize = Number(e.value);
        this.checkSize();
        break;
      case 'cbReadOnly':
        this.clone.readOnly = e.value === '1' ? true : false;
        break;
      case 'cbMassSplit':
        this.clone.massSplit = e.value === '1' ? true : false;
        break;
      case 'cbHeadInherit':
        this.clone.headInherit = e.value === '1' ? true : false;
        break;
       case 'taSettings':
        this.clone.pmdexParams = e.value;
        break;
    }
    // console.log('fi', this.clone.formulaI);
    this.manageVisibility();
  }

  /** contrôle de cohérence size / minSize */
  // TODO ajouter event + validator + check sur demande de validation
  private checkSize(): void {
    if(!this.clone.colRezisable) {
      this.clone.colMinSize = null;
      this.colMinWidth = null;
    }
    if(this.clone.colSize < this.clone.colMinSize) {
      this.clone.colSize = this.clone.colMinSize;
      this.colWidth = this.clone.colSize;
    }

    this.colMinWidth = this.clone.colMinSize;
    this.colWidth = this.clone.colSize;
    console.log('checkSize', this.clone.colSize, this.colWidth);
    this.cdref.markForCheck();
  }

  /* ##############################################################################
                   FilterFuncs pour les DS
     ############################################################################## */

  /**
   * filterFunc de la liste de fonction d'aggrégat, selon le type de la données
   * @param e la fonction
   */
  public dataKindFilter(e: PivotFunction): boolean {
    let result: boolean = false;
    if (!this.datas?.pivotField?.fkd) {
      return false;
    }
    switch (this.datas.pivotField.fkd.datakind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.CONSTANT:
        result = e.forNum;
        break;
      case FIELD_KIND.DATE:
        // console.log('this data', this.datas);
        result = e.forDate;
        break;
      case FIELD_KIND.BOOLEAN:
        result = e.forBoolean;
        break;
      case FIELD_KIND.COLOR:
        result = e.forColor;
        break;
      case FIELD_KIND.STRING:
        result = e.forString;
        break;
      default:
        result = e.forString;
        break;
    }
    return result;
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  // public dataFormatFilter(fm: FormatVO): boolean {
    
  //   console.log('dataFormatFilter obsolete');

  //   if (!this.datas?.pivotField?.fkd?.datakind) {
  //     return false;
  //   }

  //   let targetDatakind: string = this.datas.pivotField.fkd.datakind;

  //   if(this.datas.pivotField.fkd.isFreedata && this.fieldDS.selectedItem) {
  //     targetDatakind = this.fieldDS.selectedItem.dataType;
  //   } else if (this.datas.pivotField.fkd.isChrono && this.chronoFieldDS.selectedItem) {
  //     targetDatakind = this.chronoFieldDS.selectedItem.datakind;
  //   }

  //   // console.log('filter format',this.datas.pivotField.pkd.dataKind, this.datas.pivotField.fdvField);
  //   return fm.dataKind === targetDatakind;
  // }

  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    // validation du container pour contrôle de cohérence de la zone formule & aggFunc mandatory
    if(!!this.gpColumnValidator) {
      const errors: WizValidationError[] = this.gpColumnValidator.check();
      if (errors && errors.length > 0) {
        console.log('cols errors', errors);
      } else {
        this.hide();
      }
    } else {
      this.hide();
    }
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {
      // this.datas.pivotField.wizAgregateFunc = this.ddFunc?.selectedItem ? this.ddFunc.selectedItem.code : null;

      if(this.useCssStyle) {
        const style: CssRenderVO = this.cssStyleDS.selectedItem;
        const styleCode: string = style ? style.code : null;
        this.datas.pivotField.style = styleCode;
      }

      if(this.useStyle) {
        const style: StyleVO = this.styleDS.selectedItem;
        const styleCode: string = style ? style.visionCode + ViewData.KEY_SEPARATOR + style.code : null;
        if(styleCode) {
          this.datas.pivotField.style = styleCode;
        }

      }  


      const format: FormatVO = this.formatDS.selectedItem;
      const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;
      this.datas.pivotField.format = formatCode;

      if(this.datas.pivotField.fkd.isFreedata) {
        const fdvField: FreedataArgsVO = this.fieldDS.selectedItem;
        this.datas.pivotField.fdvField = fdvField ? fdvField.code : null;

        const fdvSubField: FreedataArgsVO = this.subFieldDS.selectedItem;
        this.datas.pivotField.fdvSubField = fdvSubField ? fdvSubField.code : null;

      } else if(this.datas.pivotField.fkd.isChrono) {
        const field: FakeVO = this.chronoFieldDS.selectedItem;
        this.datas.pivotField.fdvField = field ? field.code : null;
      }  



      let fdvSearch: string = null;
      if (this.fieldsDS.selectedItems) {
        const parts: Set<string> = new Set();

        this.fieldsDS.selectedItems.forEach(item=> {
          if(!!item) {
            parts.add(item.code);
          }
        });
        const orderedParts: string[] = []; // on les prend dans le bon ordre
        this.fieldsDS.getWorkedSource().forEach((arg: FreedataArgsVO) => {
          if(parts.has(arg.code)) {
            orderedParts.push(arg.code);
          }
        });

        // console.log('parts', parts, orderedParts);
        fdvSearch = orderedParts?.join(ViewData.KEY_SEPARATOR) || null;
      }
      this.datas.pivotField.fdvSearch = fdvSearch;


      this.datas.pivotField.label = this.clone.label;
      this.datas.pivotField.filtHide = this.clone.filtHide ? true: false;
      this.datas.pivotField.filtOnlyExist = this.clone.filtOnlyExist ? true: false;
      this.datas.pivotField.headerStyle = this.backgroundColor + ViewData.KEY_SEPARATOR + this.fontColor;
      this.datas.pivotField.cellStyle = this.cellBackgroundColor + ViewData.KEY_SEPARATOR + this.cellFontColor;
      this.datas.pivotField.colRezisable = this.clone.colRezisable ? true: false;
      this.datas.pivotField.colAutoSize = this.clone.colAutoSize ? true: false;
      this.datas.pivotField.colMinSize = this.clone.colMinSize;
      this.datas.pivotField.colSize = this.clone.colSize;
      this.datas.pivotField.exportable = this.clone.exportable ? true: false;


      this.datas.pivotField.readOnly = this.clone.readOnly ? true: false; // c'est l'inverse en fait, ro = éditable sur FDGRID
      this.datas.pivotField.massSplit = this.clone.massSplit ? true: false;
      this.datas.pivotField.parentGroup = !!this.groupDS.selectedItem ? this.groupDS.selectedItem.fkd.code : null;
      this.datas.pivotField.headInherit = this.clone.headInherit;
      
      this.datas.pivotField.headerAlign = !!this.headerAlignDS.selectedItem ? this.headerAlignDS.selectedItem.code : null;
      // this.datas.pivotField.cellAlign = !!this.cellAlignDS.selectedItem ? this.cellAlignDS.selectedItem.code : null;

      this.datas.pivotField.pmdexParams = this.clone.pmdexParams || null;


      this.datas.updateCallback(this.datas.baseCollector, this.datas.pivotField);
    }
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    let targetColor = null;
    if (pEvent.target === this.blockFont?.nativeElement) {
      targetColor = this.fontColor;
    } else if (pEvent.target === this.blockBack?.nativeElement) {
      targetColor = this.backgroundColor;
    } else if (pEvent.target === this.cellBlockFont?.nativeElement) {
      targetColor = this.cellFontColor;
    } else if (pEvent.target === this.cellBlockBack?.nativeElement) {
      targetColor = this.cellBackgroundColor;
    }
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(pEvent.target as HTMLElement, pEvent.target, targetColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    if (target === this.blockFont?.nativeElement) {
      this.fontColor = color;
    } else if (target === this.blockBack?.nativeElement) {
      this.backgroundColor = color;
    } else if (target === this.cellBlockFont?.nativeElement) {
      this.cellFontColor = color;
    } else if (target === this.cellBlockBack?.nativeElement) {
      this.cellBackgroundColor = color;
    }
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);

    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    const parts2: string[] = [];
    parts2.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellFontColor);
    parts2.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellBackgroundColor);

    this.cellCss = parts2.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    if (who === 'blockFont') {
      this.fontColor = 'unset'; // StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
    } else if (who === 'blockBack') {
      this.backgroundColor = 'unset'; // StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
    } else if (who === 'cellBlockFont') {
      this.cellFontColor = StyleEngine.STYLE_DEFAULT_CELL_FONT_COLOR; // --grid-header-color
    } else {
      this.cellBackgroundColor = StyleEngine.STYLE_DEFAULT_CELL_BACKGROUND_COLOR; // --grid-header-background-color
    }
    this.feedHeaderStyle();
  }

  /* ##############################################################################
                  gestion du style
    ############################################################################## */

  /** clic sur Bt édition du style en cours */
  public editStyle(): void {
    this.showStylePop(this.ddStyle.selectedItem);
  }

  /** création d'un nouveau style */
  public addStyle(): void {
    this.showStylePop(null);
  }

  /** ouverture de la popUp de configuration du style */
  private showStylePop(style: StyleVO): void {
    if (PopUpManager.exist(this.stylePop)) {
      // suppression de l'instance existante
      this.stylePop.hide();
    }
    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.stylePop = new WizPopUp(
      HeaderEditStyleSubPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '1000px',
      '350px',
      [this.model, style, this.backFromStylePop.bind(this)]
    ).show();
  }

  /**
   * modification du style conditionnel
   */
  public backFromStylePop(vo: StyleVO): void {
    // console.log('backfromstyle', vo);
    if (vo) {
      // pas de VO sur simple cancel
      const exist = this.styleDS.getItemByKey(vo.fullCode);
      if (!exist) {
        // c'est une création
        this.styleDS.addItem(vo);
        this.styleDS.select([vo]);
        this.ddStyle.wizDataProvider = this.styleDS;
      }
    }
  }

  /**
   * sort custom pour placer les searchFields sélectionnés en premier
   * @param itemA 
   * @param item 
   */
  public sortSelectedFirst(itemA: FreedataArgsVO, itemB: FreedataArgsVO): number {
    // console.log('sort', itemA, itemB, this.searchFields);
    let idxOfA: number = -1;
    let idxOfB: number = -1;
    if (this.searchFields) {
      idxOfA = this.searchFields.indexOf(itemA.code) >-1 ? this.searchFields.indexOf(itemA.code) : -1;
      idxOfB = this.searchFields.indexOf(itemB.code) >-1 ? this.searchFields.indexOf(itemB.code) : -1;
    }

    if (idxOfA === -1) {
      idxOfA = 1000 + itemA.order;
    }

    if (idxOfB  === -1) {
      idxOfB = 1000 + itemB.order;
    }

    let result: number = 1;
    if(idxOfB - idxOfA >= 0) {
      result = -1;
    }
    // console.log('##A',idxOfA, itemA.code, "##B",idxOfB, itemB.code, "##Res", result);
    return result;
  }


  protected resetSubFields(): void {
    
    // prise du champ utilisé. C'est possiblement un sous-FD
    this.arg = this.model.freedataEngine.getArgFromFD(this.datas.pivotField.fkd.code, this.clone.fdvField);
    
    if(this.arg?.dataType === FIELD_KIND.OBJECT) {
      // console.log('resetSubFields', this.clone.fdvField, this.clone.fdvSubField, this.arg.datas);
      
      // gestion du field pour le sous-FDV
      const argSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.arg.datas.split(WizConstants.CONTEXT_SEPARATOR)[0]);
      this.subFieldDS.setSource(argSrc ? [...argSrc] : []);
      let subField: FreedataArgsVO = null; // le sous-champ de FDVs
      if (this.clone.fdvSubField) {
        subField = this.subFieldDS.getItemByKey(this.clone.fdvSubField);
      }
      if(subField) {
        this.subFieldDS.select([subField]);
      }

      // gestion des champs pour la sélection
      this.fieldsDS.setSource(argSrc ? [...argSrc] : []);
      // trier fieldsDS par fdvSearch
      if (!!this.searchFields && this.searchFields.length > 0) { // champs sélectionné pour rendu des pops de sélection
        const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
        // console.log('valargs', valArgs);
        if(valArgs) {
          this.fieldsDS.select(valArgs);
        }
        this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
      } 
    }

    if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !== this.arg?.dataType) {
      if(this.arg?.dataType !== FIELD_KIND.FORMULA) {
        // console.log('this.formatDS.selectedItem',this.formatDS.selectedItem, );
        this.formatDS.clearSelection();
      }
    } 

    this.formatDS.refresh();

  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataFormatFilter(fm: FormatVO): boolean {

    let targetDatakind: string = this.datas?.pivotField?.arg?.dataType; // this.arg.dataType;

    if(targetDatakind === FIELD_KIND.FORMULA) { // tous les formats OK pour les formules
      return true;
    }

    if(this.subFieldDS.selectedItem) {
      targetDatakind = this.subFieldDS.selectedItem.dataType;
    } else if(this.fieldDS.selectedItem) {
      targetDatakind = this.fieldDS.selectedItem.dataType;
    }


    return fm.dataKind === targetDatakind;
  }

 /* ##############################################################################
          navigation
    ############################################################################## */

  public tabs: WizDatasource<WizActionObj> = null;

  /**
   * sur init, construction des tabs
   */
  private manageTabs(): void {
    
    // prise du champ utilisé. C'est possiblement un sous-FD
    this.arg = this.model.freedataEngine.getArgFromFD(this.datas.pivotField.fkd.code, this.datas.pivotField.fdvField);

    
    // selon le type et la zone cible
    let tabs: WizActionObj[] = [];
    // toujours à minima le header
    tabs.push(new WizActionObj('headTab', null, null, WizTabButton, false, null, null, null, '$.conf.headers.$', {lineColor: '#d00000'}, false, false));
   

    // et le content
    tabs.push(new WizActionObj('contentTab', null, null, WizTabButton, false, null, null, null, '$.conf.content.$', {lineColor: '#00d0d0'}, false, false));  

    if(this.datas.baseCollector?.id === 'lstFilter') { // en filter, OK
        if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA &&
          this.arg?.dataType === FIELD_KIND.OBJECT) {
            // console.log('add filter tab')
            tabs.push(new WizActionObj('filterTab', null, null, WizTabButton, false, null, null, null, '$.conf.filters.$', {lineColor: '#ee22cc'}, false, false));  
        }
      }
 
    
    // mode avancé (workflow), gestion des settings pour override de la mesure
    if(this.arg?.dataType === FIELD_KIND.WORKFLOW) {
     tabs.push(new WizActionObj('advancedTab', null, null, WizTabButton, false, null, null, null, '$.conf.advanced.$', {lineColor: '#ee22cc'}, false, false));
    }


    this.tabs = new WizDatasource<WizActionObj>(tabs).build();
    this.tabs.select([this.tabs.getSource()[0]]);
    // activation de la zone
    this.selectTab(this.tabs.getSource()[0].buttonCode);
  }


  isSelected(obj: WizActionObj): boolean {
    return this.tabs.isSelected(obj);
  }

  private clicOnTab(e: WizEvent): void {
    // console.log('clicOnTab', this.tabs.selectedItem);
    this.selectTab(this.tabs.selectedItem?.buttonCode);
  }

  private selectTab(who: string): void {
    // console.log('selectTab', who);
    this.headTab = false;
    this.contentTab = false;
    this.filterTab = false;
    this.advancedTab = false;
    this[who] = true;
  }


}
